// mgmt
import petrovics from "assets/images/team/ppetrovics.jpg";
import kszabo from "assets/images/team/kszabo.jpg";
import bdebreczeni from "assets/images/team/bdebreczeni.jpg";
import vszathmary from "assets/images/team/vszathmary.jpg";

// team
import aridovics from "assets/images/team/aridovics.jpg";
import ztreer from "assets/images/team/ztreer.jpg";
import rszaloki from "assets/images/team/rszaloki.jpg";
import bforrai from "assets/images/team/bforrai.jpg";
import jero from "assets/images/team/jero.jpg";

// contributors
import emarton from "assets/images/team/emarton.jpg";
import bjackson from "assets/images/team/bjackson.jpg";
import thume from "assets/images/team/thume.jpg";
import lheves from "assets/images/team/lheves.jpg";
import vkontra from "assets/images/team/vkontra.jpg";
import gycsado from "assets/images/team/gycsado.jpg";
import tnadrai from "assets/images/team/tnadrai.jpg";
import pkolcza from "assets/images/team/pkolcza.jpg";
import dkovacs from "assets/images/team/dkovacs.jpg";

import decentlabs from "assets/images/decentlabs.png";

export const management = [
    {
        pk: "petrovics",
        firstName: "Péter",
        lastName: "Petrovics",
        imgSrc: petrovics,
        title: "Co-founder, technologist",
        linkedinUrl: "https://www.linkedin.com/in/petrovics",
        githubUrl: "https://github.com/szerintedmi",
        description:
            "Péter is a serial entrepreneur with 20+ years technical, management and financial experience. He ran his own software house for nine years, managed tons of software projects and launched several successful startups, including Hungary's largest social network before Facebook."
    },
    {
        pk: "kszabo",
        firstName: "Károly",
        lastName: "Szabó",
        imgSrc: kszabo,
        title: "Co-founder, economist",
        githubUrl: "https://github.com/krosza",
        description:
            "Károly is an entrepreneur with 30+ years management and financial experience. He managed and set up government agencies and business companies, supervised IT development projects. He worked a decade as a managing director of one of the largest Hungarian banks."
    },
    {
        pk: "vszathmary",
        firstName: "Viktor",
        lastName: "Szathmáry",
        imgSrc: vszathmary,
        title: "Strategic Advisor",
        linkedinUrl: "https://www.linkedin.com/in/phraktle",
        githubUrl: "https://github.com/phraktle",
        description:
            "Software developer, entrepreneur, angel investor. Founder of decent.org, a non-profit organization researching and promoting decentralized technologies. 20 years of experience in building startups."
    },
    {
        pk: "bdebreczeni",
        firstName: "Barnabás",
        lastName: "Debreczeni",
        imgSrc: bdebreczeni,
        title: "Cryptocurrency specialist, Shinrai founder",
        linkedinUrl: "https://www.linkedin.com/in/bdebreczeni",
        description:
            "Pioneer of decentralised cryptocurrencies, active member of blockchain community, officer of the Hungarian Blockchain Society and organizer of blockchain meetups."
    }
];

export const teamMembers = [
    {
        pk: "aridovics",
        firstName: "Ádám",
        lastName: "Ridovics",
        imgSrc: aridovics,
        title: "Frontend developer, designer",
        linkedinUrl: "https://www.linkedin.com/in/adamridovics/",
        description:
            "Frontend developer, creative & designer with years of experience in visual communication, ui, ux & product design and building & managing products/startups from the ground up."
    },
    {
        pk: "ztreer",
        firstName: "Zoltán",
        lastName: "Treer",
        imgSrc: ztreer,
        title: "Blockchain developer",
        description: ""
    },
    {
        pk: "rszaloki",
        firstName: "Róbert",
        lastName: "Szalóki",
        imgSrc: rszaloki,
        title: "Frontend developer",
        linkedinUrl: "https://www.linkedin.com/in/robertszaloki/",
        description: ""
    },
    {
        pk: "bforrai",
        firstName: "Brigitta",
        lastName: "Forrai",
        imgSrc: bforrai,
        title: "Frontend developer, designer",
        linkedinUrl: "https://www.linkedin.com/in/brigitta-forrai-6639b152/",
        description: ""
    },
    {
        pk: "jero",
        firstName: "Júlia",
        lastName: "Erő",
        imgSrc: jero,
        title: "Frontend developer",
        linkedinUrl: "https://www.linkedin.com/in/juliaero/",
        description: ""
    }
];

export const contributors = [
    {
        pk: "team-3",
        firstName: "Márton",
        lastName: "Elek",
        imgSrc: emarton,
        title: "Marketing, PR strategy",
        linkedinUrl: "https://www.linkedin.com/in/marton-elek",
        description:
            "Network building specialist with creative marketing and PR strategy skills. 25 years startup building experience with focus on UX  and conscious branding"
    },
    {
        pk: "team-6",
        firstName: "Ben",
        lastName: "Jackson",
        imgSrc: bjackson,
        title: "Blockchain developer",
        linkedinUrl: "https://www.linkedin.com/in/ben-jackson-0686a896",
        githubUrl: "https://github.com/BYossarian",
        description:
            "Software developer, and former mathematician, who loves the wild west of decentralised technologies."
    },
    {
        pk: "team-7",
        firstName: "Tom",
        lastName: "Hume",
        imgSrc: thume,
        title: "Branding & Visual",
        linkedinUrl: "https://www.linkedin.com/in/tom-hume-31b64014a",
        portfolio: "http://studiojubilee.com",
        description:
            "Partner of <a href='http://studiojubilee.com' target='_blank'>Studio Jubilee</a>, a design practice focused on branding, digital design, and strategy. <a href='http://studiojubilee.com' target='_blank'>Studio Jubilee</a> works with innovative startups and global brands."
    },
    {
        pk: "team-8",
        firstName: "László",
        lastName: "Heves",
        imgSrc: lheves,
        title: "Frontend, UX developer",
        linkedinUrl: "https://www.linkedin.com/in/lheves",
        githubUrl: "https://github.com/reyrodrigez",
        description:
            "Laci has 8+ years of experience building medium and large sized websites and applications . He helps in building the frontend but also  making sure users have a great experience using Augmint."
    },
    {
        pk: "team-9",
        firstName: "Verka",
        lastName: "Kontra",
        imgSrc: vkontra,
        title: "Financial expert",
        linkedinUrl: "https://www.linkedin.com/in/veronika-kontra-321328143",
        description: "Finance professional with 5+ years of experience in valuation, financial modeling and analysis."
    },
    {
        pk: "team-10",
        firstName: "György",
        lastName: "Csadó",
        imgSrc: gycsado,
        title: "Frontend developer",
        linkedinUrl: "https://www.linkedin.com/in/gy%C3%B6rgy-csad%C3%B3-771739bb",
        githubUrl: "https://github.com/gyurka00",
        description:
            "Gyurka is experienced making sites work as good as they look. He works on Augmint<a href='https://euedge.com' target='_blank'> from EU Edge.</a>"
    },
    {
        pk: "team-11",
        firstName: "Tamás",
        lastName: "Nadrai",
        imgSrc: tnadrai,
        title: "Full stack developer",
        linkedinUrl: "https://www.linkedin.com/in/nadrai/",
        githubUrl: "https://github.com/CryppTom",
        description:
            "Tamas has 8+ years experience in software development and testing. He is a blockchain and cryptocurrency enthusiast since 2017."
    },
    {
        pk: "team-12",
        firstName: "Péter",
        lastName: "Kolcza",
        imgSrc: pkolcza,
        title: "IT consultant, backend developer",
        linkedinUrl: "https://www.linkedin.com/in/p%C3%A9ter-kolcza-0b04bb8/",
        description:
            "Peter has 10+ years of experience in building enterprise solutions for financial institutions in the areas of loans and data quality. He performs best when complex problems should be solved: when technology meets finance, tax, business and complience."
    },
    {
        pk: "team-13",
        firstName: "Dávid",
        lastName: "Kovács",
        imgSrc: dkovacs,
        title: "Project management",
        linkedinUrl: "https://www.linkedin.com/in/kovacsd/",
        description:
            "David’s background is in Project Management - he has lived in several countries, having most recently spent 2 years in San Francisco in the tech startup scene. Outside of work, he is a triathlete and ultra runner."
    }
];

export const partners = [
    {
        pk: "partner-1",
        name: "Decent Labs",
        imgSrc: decentlabs,
        description:
            "<a href='http://www.decent.org/' target='_blank'>Augmint was born at Decent Labs.</a> It supports Augmint as a technical partner."
    }
];
